// Default execution-tab choice for the EHR sync/mapping tab picker.
//
// Precedence:
//   1. The tab the user last actually clicked a field in (`lastInteracted`, reported
//      by newer chrome-extension builds via getTabs; absent on older builds).
//   2. The tab used by the previous run, when it is still open.
//   3. The first candidate tab (legacy behavior).
//
// Blind tabs[0] was the root of the "mapping buttons only work on the first patient
// tab" complaint: with several EHR tabs open, every run silently targeted whichever
// happened to sit first in the tab strip.
export function pickDefaultExecutionTab(tabs, previousTabId) {
  if (!Array.isArray(tabs) || tabs.length === 0) return undefined;

  const lastInteracted = tabs.find((t) => t && t.lastInteracted);
  if (lastInteracted) return lastInteracted.id;

  const prev = parseInt(previousTabId);
  if (Number.isFinite(prev)) {
    const previous = tabs.find((t) => t && t.id === prev);
    if (previous) return previous.id;
  }

  return tabs[0]?.id;
}
